define('modules/editor/models/linkedinapi',['require','exports','module','backbone'],function(require, exports, module){
	"use strict";
	var Backbone = require("backbone");
	var LinkedInAPI = Backbone.Model.extend({
    defaults: {
      appId: ""
    }
  });

  module.exports = LinkedInAPI;
});

